const routes = [
    {
        path: "dashboard",
        name: "Dashboard",
        component: () => import('@/modules/gestion/views/dashboard/Dashboard.vue'),
    },
    {
        path: "facturas",
        name: "Facturas",
        component: () => import('@/modules/gestion/views/facturas/Facturas.vue'),
    },
    {
        path: "facturas-resumen",
        name: "FacturasResumen",
        component: () => import('@/modules/gestion/views/facturasResumen/Facturas.vue'),
    },
    {
        path: "ventas",
        name: "Ventas",
        component: () => import('@/modules/gestion/views/ventas/Ventas.vue'),
    },
    {
        path: "pagos-proveedores",
        name: "PagosProveedores",
        component: () => import('@/modules/gestion/views/pagoProveedores/PagoProveedores.vue'),
    },
    {
        path: "movimientos-cuentas",
        name: "MovimientosCuentas",
        component: () => import('@/modules/gestion/views/movimientosCuentas/MovimientosCuentas.vue'),
    },
    {
        path: "laminas",
        name: "laminasDoblaje",
        component: () => import('@/modules/gestion/views/laminasDoblaje/LaminasDoblaje.vue'),
    },
    {
        path: "doblajes",
        name: "historialDoblajes",
        component: () => import('@/modules/gestion/views/historialDoblajes/HistorialDoblajes.vue'),
    },

];

export default routes;
